<template>
<select-parcels :parcelList="childselectedParcels" :texts="texts"></select-parcels>
<section class="quotation-section custom-container">
    <div v-if="isAdminBoolean" class="form-row mt-1">
        <div class="form-group w-100">
            <label class="font-semibold">Cotizar como usuario</label>
            <select
                class="custom-input"
                v-model="selectedUserId"
                :disabled="isLoadingUsers"
            >
                <option value="">Usar mi Cuenta</option>
                <option v-if="isLoadingUsers" disabled>Consultando usuarios...</option>
                <option
                    v-for="user in adminUsers"
                    :key="user.value"
                    :value="user.value"
                >
                    {{ user.label }}
                </option>
            </select>
            <p v-if="!isLoadingUsers && adminUsers.length === 0" class="text-caption mt-1">
                Aún no hay usuarios disponibles para seleccionar.
            </p>
        </div>
    </div>
    <QuotationForm
        v-model:form="form"
        v-model:alert="alert"
        v-model:unitSystem="unitSystem"
        v-model:quotOnlyImportation="quotOnlyImportation"
        :parcelsInProcess="parcelsInProcess"
        :btnDisabled="isQuoting"
        :texts="texts"
        :quotImportation="quotImportation"
        @trackFieldFocus="trackFormFieldFocus"
        @submitForm="handleSubmit"
    ></QuotationForm>

    <div class="card shadow" v-if="quotations.length > 0">
        <div class="cad-body row" style="gap: 2%">
            <MobileQuotItem
                v-for="item, index in quotationsSorted"
                :key="index"
                :quotation="item"
                class="w-100 mb-2"
                @on-select="createOrderForm(item)"
                classCard="size-quot-card"
                :merge-huipix-costs="shouldMergeHuipixCosts"
            ></MobileQuotItem>
        </div>
    </div>

    <ModalComponent v-model="customQuotation.show">
        <div class="pa-2">
            <div class="w-100">
                <span class="text-medium text-h6">⚠️ Para continuar con tu cotización, necesitamos tu número de WhatsApp.</span>
            </div>

            <div class="w-100 mt-2">
                <span class="mt-1">Esta cotización, debido a sus dimensiones o peso, se considera una cotización especial. Será atendida de forma personalizada.</span>
            </div>

            <form @submit.prevent="sendWhatsappMessage">
                <PhoneInput
                    class="w-100 mt-1"
                    v-model:phone="customQuotation.form.phone_number"
                    v-model:dialCode="customQuotation.form.dial_code"
                ></PhoneInput>

                <BasicTextArea
                    class="mt-1"
                    v-model="customQuotation.form.description"
                    label="Descripción del contenido"
                ></BasicTextArea>

                <TransitionLabel
                    :show="customQuotation.alert.show"
                    labelClass="mt-1 text-caption danger-color"
                >
                    {{ customQuotation.alert.message }}
                </TransitionLabel>

                <LoadingButton
                    label="Conocer cotizaicion"
                    :loading="customQuotation.loading"
                    class="w-100 mt-1"
                />
            </form>
        </div>
    </ModalComponent>
</section>
</template>

<script>
import { useSwalFire } from '../../composables/useSwalFire';
import { useScreen } from '../../composables/useScreen';
import CustomTable from '../../global-components/custom-table.vue';
import TransitionLabel from '../../global-components/TransitionLabel.vue';
import apiClient from '../../services/apiClient';
import selectParcels from './select-parcels.vue';
import Badge from '../../global-components/Badge.vue';
import ItemBadge from '../../global-components/ItemBadge.vue';
import PrimaryBadge from '../../global-components/PrimaryBadge.vue';
import MobileQuotItem from './MobileQuotItem.vue';
import utils from '../../composables/utils';
import UnitSelector from '../../global-components/UnitSelector.vue';
import { useGoogleAnalytics } from '../../composables/useGoogleAnalytics';
import ModalComponent from '../../global-components/ModalComponent.vue';
import LoadingButton from '../../global-components/LoadingButton.vue';
import BasicInput from '../../global-components/basic-input.vue';
import PhoneInput from '../../global-components/PhoneInput.vue';
import QuotationForm from '../../global-components/quotations/QuotationForm.vue';
import BasicTextArea from '../../global-components/BasicTextArea.vue';

export default {
    name: 'quot-form',
    components: {
        selectParcels,
        CustomTable,
        TransitionLabel,
        Badge,
        ItemBadge,
        PrimaryBadge,
        MobileQuotItem,
        UnitSelector,
        LoadingButton,
        ModalComponent,
        BasicInput,
        PhoneInput,
        QuotationForm,
        BasicTextArea
    },
    props: {
        isAdmin: {
            type: Boolean,
            default: false
        },
        isLogged: {
            type: String,
            required: true,
        },
        parcels: {
            type: String,
            required: true
        },
        quotImportation: {
            type: String,
            default: 'false'
        },
        pageData: {
            type: String,
            default: 'null'
        },
        userEmail: {
            type: String,
            default: null
        }
    },
    setup () {
        const { isMobile } = useScreen()
        const {trackPageView, trackFormFieldFocus, trackFormSubmission} = useGoogleAnalytics()
        return { isMobile, trackPageView, trackFormFieldFocus, trackFormSubmission }
    },
    data() {
        const isHuipix = window?.location?.hostname === 'importaciones.huipixenvios.com.mx'
        return{
            isHuipix,
            childselectedParcels: [],
            unitSystem: 'metric', // || 'imperial'
            alert: {
                show: false,
                message: ''
            },
            form: {
                cost: null,
                destination: '',
                length: null,
                weight: null,
                width: null,
                height: null,
                chboxDimensions: false
            },
            normalizedForm: null,
            isQuoting: false,
            parcelsInProcess: [],
            adminUsers: [],
            selectedUserId: '',
            isLoadingUsers: false,
            quotations: [],
            parcelError: {
                FEDEX: null,
                DHL: null,
                PAQUETEXPRESS: null,
                ESTAFETA: null
            },
            quotOnlyImportation: false,
            swalFire: null,
            utils: utils,
            texts: {
                title: 'Cotizador',
                description: 'Lorem ipsum dolor sit amet consectetur adipisicing elit. Quae accusamus fugit dolorem necessitatibus minima odit animi! Reprehenderit, quidem sed beatae nihil, explicabo recusandae minima nesciunt suscipit aperiam quae, quibusdam esse.',
                subtitle: 'Peso y dimensiones',
                subtitle_description: 'Lorem ipsum dolor sit, amet consectetur adipisicing elit. Eius, saepe? Odio temporibus ab earum sed, nihil ad harum quia numquam labore rerum, rem dicta tempore soluta architecto commodi cupiditate debitis?'
            },
            customQuotation: {
                show: false,
                form: {
                    phone_number: '',
                    dial_code: '+52',
                    description: ''
                },
                alert: {
                    message: '',
                    show: false
                },
                loading: false
            },
            excedeedDimensions: false
        }
    },
    methods: {
        handleSubmit (formData) {
            const payload = {
                ...formData,
                ...this.getQuoteUserPayload()
            };
            console.log(payload)
            this.normalizedForm = { ...formData }
            this.parcelError = {
                FEDEX: null,
                DHL: null,
                PAQUETEXPRESS: null,
                ESTAFETA: null
            }
            this.clearTable();
            this.trackFormSubmission('on_submit_quotation_form');
            this.excedeedDimensions = false;
            this.isQuoting = true;
            this.parcelsInProcess = this.childselectedParcels.map((parcel) => parcel.name);
            for (let parcel of this.childselectedParcels) {
                if (this.quotOnlyImportation) this.onQuotIportation(payload);
                else this.quotParcel(payload, parcel.name, parcel.is_preferred);
            }
        },
        getQuoteUserPayload () {
            if (this.isAdminBoolean && this.selectedUserId) {
                return { quote_user_id: this.selectedUserId };
            }
            return {};
        },
        async loadAdminUsers () {
            if (!this.isAdminBoolean) return;
            this.isLoadingUsers = true;
            try {
                const response = await apiClient.get('/api/users/quote-targets');
                const users = response.data?.data ?? [];
                this.adminUsers = users.map(({ id, name, last_name, company }) => {
                    const companyLabel = company && company.name ? ` - ${company.name}` : '';
                    return {
                        value: id,
                        label: `${name} ${last_name}${companyLabel}`
                    };
                });
            } catch (error) {
                this.swalFire.onCatchError(error);
            } finally {
                this.isLoadingUsers = false;
            }
        },
        handleData(data) {
            this.childselectedParcels = data;
        },
        onQuotIportation (payload) {
            
            const token = localStorage.getItem('access_token');
            apiClient.post('/api/order/quote/importation', payload, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            }).then((response) => {
                if (response.data.data) {
                    const quotation = response.data.data
                    if (this.shouldMergeHuipixCosts) {
                        quotation.price = Number(quotation.price) + Number(quotation.importation || 0)
                        quotation.importation = 0
                    }
                    this.quotations = [quotation]
                }
            }).catch((error) => {
                console.log(error)
            }).finally(() => {
                this.isQuoting = false;
            })
        },
        quotParcel(payload, parcel, isPreferred) {
            const token = localStorage.getItem('access_token');
            apiClient.post('/api/order/quote', {...payload, parcel}, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })
            .then((data) => {
                if (data.data.error_dimensions) {
                    this.excedeedDimensions = true;
                }
                if (!data.data.error_dimensions) {
                    const mapped = data.data.responseDetails.map((item) => {
                        const q = { ...item, isPreferred }
                        if (this.shouldMergeHuipixCosts) {
                            q.price = Number(q.price) + Number(q.importation || 0)
                            q.importation = 0
                        }
                        return q
                    })
                    this.quotations = [...this.quotations, ...mapped]
                    return
                }

                if (this.parcelsInProcess.length === 1 && this.excedeedDimensions) {
                    this.customQuotation.form.phone_number = data.data.phone_number
                    this.customQuotation.form.dial_code = data.data.dial_code
                    this.openCustomQuotationDialog()
                }
                /* if (data.data.responseDetails.length === 0) {
                    this.setInvalidParcel(parcel)
                    if (data.data.message) this.alert.message = data.data.message
                } */
            })
            .catch((error) => {
                this.swalFire.onCatchError(error)
                // this.setInvalidParcel(parcel)
            })
            .finally(() => {
                this.parcelsInProcess = this.parcelsInProcess.filter(p => p !== parcel)
                if(this.parcelsInProcess.length === 0) {
                    this.isQuoting = false;
                    if (!this.quotations.length) this.alert.show = true
                }
            })
        },
        setInvalidParcel (parcel) {
            this.quotations.push({
                parcelCompany: parcel,
                data: 'En este momento no hay cobertura con esta paquetería',
                error: true,
                totalAmount: 0
            })
            const index = this.quotations.findIndex((data) => data.parcelCompany === parcel)
            this.parcelError[parcel] = index
        },
        clearTable() {
            this.quotations = []
        },
        formatCurrency(number) {
            return number.toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            });
        },
        createOrderForm(response) {
            this.trackFormSubmission('on_select_quotation')
            const request = this.normalizedForm
                ? JSON.parse(JSON.stringify(this.normalizedForm))
                : {
                    ...this.form,
                    unitSystem: this.unitSystem,
                    originalValues: JSON.parse(JSON.stringify(this.form)),
                    originalUnitSystem: this.unitSystem
                }
            sessionStorage.setItem('quotationRequest', JSON.stringify(request))
            sessionStorage.setItem('quotationResponse', JSON.stringify(response))
            location.href = this.isLoggedBoolean ? '/order/create' : '/register'
        },
        openCustomQuotationDialog () {
            this.customQuotation.alert.show = false
            this.customQuotation.show = true
        },
        sendWhatsappMessage() {
            const {phone_number, description} = this.customQuotation.form
            if (phone_number === '' || phone_number.length !== 10) {
                this.customQuotation.alert.message = 'Necesitamos un número de teléfono válido para continuar y enviarte tu cotización por WhatsApp.'
                this.customQuotation.alert.show = true
                return
            }

            if (!description || description === '') {
                this.customQuotation.alert.message = 'Ingresa la Descripción del Contenido del Paquete para Continuar.';
                this.customQuotation.alert.show = true
                return
            }

            apiClient.post('/api/order/special/quote', {
                description,
                phone_number: `${this.customQuotation.form.dial_code}${this.customQuotation.form.phone_number}`,
                unitSystem: this.unitSystem,
                ...this.form
            }).then(() => {
                this.customQuotation.show = false
                this.successMessageCustomQuotation()
            }).catch((error) => {
                this.swalFire.onCatchError(error)
            })
        },
        successMessageCustomQuotation () {
            this.customQuotation.form.description = ''
            this.customQuotation.form.phone_number = ''
            this.customQuotation.form.dial_code = '+52'

            this.swalFire.onSuccessNotify({
                title: '¡Listo!',
                label: 'Te contactaremos por WhatsApp en breve para continuar con tu cotización.'
            });
        }
    },
    computed: {
        isAdminBoolean() {
            return this.isAdmin === true || this.isAdmin === 'true';
        },
        isLoggedBoolean() {
            return this.isLogged === 'true'; // Convertir explícitamente
        },
        shouldMergeHuipixCosts() {
            if (!this.isHuipix) return false;

            const normalizedEmail = typeof this.userEmail === 'string'
                ? this.userEmail.trim().toLowerCase()
                : '';

            return normalizedEmail !== 'asesor@huipix.com';
        },
        columnsQuotations() {
            return [
                { name: 'parcel-company', label: 'Paquetería', field: 'parcelCompany', format: (val) => this.utils.getParcelLabel(val) },
                { name: 'service', label: 'Servicio', field: 'service' },
                { name: 'delivery-date', label: 'Entrega', field: 'deliveryDate' },
                { name: 'price', label: 'Envío', field: 'price', format: (val) => this.formatCurrency(val) },
                ...(!this.shouldMergeHuipixCosts ? [{ name: 'importation', label: 'Cruce', field: 'importation', format: (val) => this.formatCurrency(val) }] : []),
                { name: 'total-extra-charges', label: 'Cargos', field: 'totalExtraCharges', format: (val) => this.formatCurrency(val) },
                { name: 'total-amount', label: 'Total', field: 'totalAmount', format: (val) => this.formatCurrency(val) },
                { name: 'actions', label: '', field: '' },
            ];
        },
        quotationsSorted() {
            return this.quotations.sort((a, b) => {
                if (a.isPreferred && !b.isPreferred) return -1;
                if (!a.isPreferred && b.isPreferred) return 1;
                return a.totalAmount - b.totalAmount;
            })
        },
    },
    mounted() {
        this.swalFire = useSwalFire()
        if (this.isAdminBoolean) {
            this.loadAdminUsers()
        }
        const parcelList = JSON.parse(this.parcels)
        this.childselectedParcels = parcelList.map((parcel) => ({name: parcel.name, is_preferred: parcel.is_preferred === 1}))
        if (this.pageData !== 'null') {
            this.texts = typeof this.pageData === 'object' ? this.pageData : JSON.parse(this.pageData)
        }
        this.trackPageView('QUOTATION_PAGE')
    }
}
</script>
